import React, { useState, useEffect } from 'react';
import './CookieConsent.css';

function loadTracking(prefs) {
    if (prefs.analytics) {
        const trackingId = process.env.REACT_APP_GOOGLE_ANALYTICS_ID || 'G-XXXXXXXXXX';
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
        document.head.appendChild(script);

        window.dataLayer = window.dataLayer || [];
        function gtag() { window.dataLayer.push(arguments); }
        window.gtag = gtag;
        gtag('js', new Date());
        gtag('config', trackingId);
    }

    if (prefs.marketing) {
        console.log('Marketing cookies enabled');
    }

    if (prefs.preferences) {
        console.log('Preference cookies enabled');
    }
}

function CookieConsent() {
    const [showConsent, setShowConsent] = useState(false);
    const [preferences, setPreferences] = useState({
        essential: true,
        analytics: false,
        marketing: false,
        preferences: false
    });

    useEffect(() => {
        const hasConsent = localStorage.getItem('cookieConsent');
        if (!hasConsent) {
            setShowConsent(true);
            return;
        }

        const savedPreferences = localStorage.getItem('cookiePreferences');
        if (savedPreferences) {
            const parsed = JSON.parse(savedPreferences);
            setPreferences(parsed);
            loadTracking(parsed);
        }
    }, []);

    const handleAcceptAll = () => {
        const allAccepted = {
            essential: true,
            analytics: true,
            marketing: true,
            preferences: true
        };
        setPreferences(allAccepted);
        localStorage.setItem('cookieConsent', 'true');
        localStorage.setItem('cookiePreferences', JSON.stringify(allAccepted));
        setShowConsent(false);
        loadTracking(allAccepted);
    };

    const handleRejectAll = () => {
        const onlyEssential = {
            essential: true,
            analytics: false,
            marketing: false,
            preferences: false
        };
        setPreferences(onlyEssential);
        localStorage.setItem('cookieConsent', 'true');
        localStorage.setItem('cookiePreferences', JSON.stringify(onlyEssential));
        setShowConsent(false);
        loadTracking(onlyEssential);
    };

    const handleSavePreferences = () => {
        localStorage.setItem('cookieConsent', 'true');
        localStorage.setItem('cookiePreferences', JSON.stringify(preferences));
        setShowConsent(false);
        loadTracking(preferences);
    };

    const handleToggle = (key) => {
        if (key !== 'essential') {
            setPreferences(prev => ({
                ...prev,
                [key]: !prev[key]
            }));
        }
    };

    if (!showConsent) {
        return null;
    }

    return (
        <div className="cookie-consent-overlay">
            <div className="cookie-consent-modal">
                <div className="cookie-consent-header">
                    <h2>🍪 Cookie & Privacy Settings</h2>
                    <p>We use cookies to enhance your experience and comply with data protection laws (GDPR & CCPA). You can still navigate our website while you decide.</p>
                </div>

                <div className="cookie-consent-content">
                    <div className="cookie-category">
                        <div className="category-header">
                            <input
                                type="checkbox"
                                id="essential"
                                checked={preferences.essential}
                                disabled
                                onChange={() => handleToggle('essential')}
                            />
                            <label htmlFor="essential">
                                <strong>Essential</strong>
                            </label>
                        </div>
                        <p className="category-description">
                            Required for security and authentication
                        </p>
                    </div>

                    <div className="cookie-category">
                        <div className="category-header">
                            <input
                                type="checkbox"
                                id="analytics"
                                checked={preferences.analytics}
                                onChange={() => handleToggle('analytics')}
                            />
                            <label htmlFor="analytics">
                                <strong>Analytics</strong>
                            </label>
                        </div>
                        <p className="category-description">
                            Understand how you use our site
                        </p>
                    </div>

                    <div className="cookie-category">
                        <div className="category-header">
                            <input
                                type="checkbox"
                                id="marketing"
                                checked={preferences.marketing}
                                onChange={() => handleToggle('marketing')}
                            />
                            <label htmlFor="marketing">
                                <strong>Marketing</strong>
                            </label>
                        </div>
                        <p className="category-description">
                            Personalized advertisements
                        </p>
                    </div>

                    <div className="cookie-category">
                        <div className="category-header">
                            <input
                                type="checkbox"
                                id="preferences"
                                checked={preferences.preferences}
                                onChange={() => handleToggle('preferences')}
                            />
                            <label htmlFor="preferences">
                                <strong>Preferences</strong>
                            </label>
                        </div>
                        <p className="category-description">
                            Remember your settings
                        </p>
                    </div>

                    <div style={{ gridColumn: '1 / -1' }}>
                        <div className="cookie-links">
                            <a href="/terms-and-conditions" target="_blank" rel="noopener noreferrer">Terms and Conditions</a>
                            <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                            <a href="/cookie-policy" target="_blank" rel="noopener noreferrer">Cookie Policy</a>
                        </div>
                    </div>
                </div>

                <div className="cookie-consent-footer">
                    <button 
                        className="btn btn-secondary" 
                        onClick={handleRejectAll}
                    >
                        Reject All
                    </button>
                    <button 
                        className="btn btn-outline-primary" 
                        onClick={handleSavePreferences}
                    >
                        Save Preferences
                    </button>
                    <button 
                        className="btn btn-primary" 
                        onClick={handleAcceptAll}
                    >
                        Accept All
                    </button>
                </div>
            </div>
        </div>
    );
}

export default CookieConsent;